import { render, staticRenderFns } from "./x-radio-group.vue?vue&type=template&id=5514cb4f&scoped=true&"
import script from "./x-radio-group.vue?vue&type=script&lang=js&"
export * from "./x-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./x-radio-group.vue?vue&type=style&index=0&id=5514cb4f&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514cb4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/welearn-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5514cb4f', component.options)
    } else {
      api.reload('5514cb4f', component.options)
    }
    module.hot.accept("./x-radio-group.vue?vue&type=template&id=5514cb4f&scoped=true&", function () {
      api.rerender('5514cb4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/x-radio-group.vue"
export default component.exports